import {docketGeneralInfo,getPartyInfo,documentTypes,uploadDocs,isFileExists,encrypt,decrypt,externalPendingRejectedDocs,getDocketsList,updateEservicePreference,getCurrentUserData} from "../services/http-services/HttpServices";
import { SET_DOCKET_GENERAL_INFO,SET_PARTY_INFO,SET_DOCUMENT_TYPES,errorMessage,SET_REJECTED_PENDING_TYPES,eStoragebaseURL,apibaseURL,SET_DOCKETS } from "../config";
// import { validateForm } from "../services/helper/Form1Helper";
import { getCookie } from "../services/helper/Helper";
import { showLoader,hideLoader, notification,showHideModal,showHideThankYouModal } from "./uiAction";
import { actions } from "react-redux-form";
import { validateAndCheckErrors } from "../services/helper/YupValidationHelper";
import { history } from "../services/helper/Helper";

/* Name : Neha Desc : Function is used to fetch all the information based on the docket number. */
export function getDocketGeneralInfo(data) {
  return function(dispatch) {
		dispatch(showLoader())
		 return docketGeneralInfo(data)
			.then(json=>{
				dispatch(hideLoader())
				//console.log()
				if(json.status=='false')
				{
					dispatch(notification("We're unable to provide access to the case information. Please contact judge assistant on your Notice of Hearing."));
					history.push('/publicAccess/dashboard');
				}else{
					 dispatch({
						type: SET_DOCKET_GENERAL_INFO,
						docketGenaralInfo:json
					  })
					  dispatch(actions.change("eServiceForm",{e_services: json.eServices.e_services}))
				}
				 
					  
			})
			
		}
     
    }
/* Name : Neha
   Description : Function is used to fetch the individual party information.
*/
export function viewPartyInfo(data)
{
	return function(dispatch) {
		dispatch(showLoader())
		 return getPartyInfo(data)
			.then(json=>{

				if(json == 0 || json == '0') {
					dispatch(notification("Party Information not found."));
				}

				dispatch({
					type: SET_PARTY_INFO,
					partyInfo:json
					})
				 dispatch(hideLoader())
			})
			
		}
}
/* Name : Neha
   Description : Function is used to get all the document types.
*/
export function getDocumentTypes()
{
	return function(dispatch) {
		return documentTypes()
			.then(json=>{
			  dispatch({
					type: SET_DOCUMENT_TYPES,
					documentTypes:json
				})
			})
			
		}
}
/* Name : Neha
   Description : Function is used to get all the document types.
*/
export function getDockets()
{
	return function(dispatch) {
		return getDocketsList()
			.then(json=>{
			  dispatch({
					type: SET_DOCKETS,
					caseids:json.totalCaseid
				})
			dispatch(actions.change("findCaseform.e_services",json.e_services))
			})
			
		}
}

export function changeAction(model,value) {
  return function(dispatch) {
    dispatch(actions.change(model, value))
  }
}
/* Name : Neha Agrawal
   Description : Function is used to download and view the files if physically exists.
 */
export function downloadFiles(documentId,flag=0,tableFlag) {
	return function(dispatch) {
		dispatch(showLoader())
		var data = JSON.stringify({documentId:documentId,tableFlag:tableFlag});
		return isFileExists(data)
			.then(response => {
				if(response != 0 || response != '0') {
					response = decrypt(response);
				}

				dispatch(hideLoader())
				if(response!='0')
				{
					//window.open((flag?(apibaseURL+'downloadDocuments/'+documentId+'/'+tableFlag):apibaseURL+response));
					window.open((flag?(apibaseURL+'downloadDocuments/'+documentId+'/'+tableFlag):eStoragebaseURL+response));
				}else{
					dispatch(notification("File Does Not Exist!"));
					// setTimeout(()=>dispatch(notification),0)  
				}
			});
  }
}

/* Name : Neha
   Description : Function is used to get all the document types.
*/
export function getRejectedPendingDocs(docketno)
{
	return function(dispatch) {
		dispatch(showLoader())
		return externalPendingRejectedDocs(docketno)
			.then(json=>{
				dispatch(hideLoader())
			  dispatch({
					type: SET_REJECTED_PENDING_TYPES,
					externalDocumentTypes:json
				})
			})
			
		}
}




/* Name : Neha
   Description : Function is used to upload the files in the database.
*/
export function uploadDocFiles(data,Schema)
{
	//let value=getCookie(btoa("publicAccess"));
	//let userId = JSON.parse(atob(value)).user_id;

	return async function (dispatch,getState)  {
		let {uploadFile} = getState();

		let userId = await getCurrentUserData(); 
		userId = userId.user_id;

		validateAndCheckErrors(dispatch,Schema,uploadFile).then(flag=>{
			 if(flag) {
				let formData = new FormData();
				formData.append('files', uploadFile.files[0]);
				formData.append('data', encrypt(JSON.stringify({...uploadFile,userId:userId,files:undefined})));
				dispatch(showLoader())
				return uploadDocs(formData)
			.then(response => {
				 dispatch(hideLoader())
				if(response.result)
				{
					dispatch(showHideModal(false));
					dispatch(showHideThankYouModal(true));
					
				} else if(response.result == false && response.errorType == 2) {
					dispatch(notification('Please remove special characters from your filename (rename) and try again'))
				} else if(response.result == false && response.errorType == 3) {
					dispatch(notification('Only jpeg, png, pdf will be accepted'))
				} else {
					dispatch(notification(errorMessage.tryAgain))
				}
			})
			 }
		})
	}
}
export function updatePrefernce(data,caseid)
{
	let value = {eService : data, caseid : caseid}
	return function(dispatch) {
		dispatch(showLoader())
		return updateEservicePreference(value)
			.then(response=>{
				dispatch(hideLoader())
			  if(response.status=='1')
				{
					dispatch(notification("You have successfully updated your eService preference."));
				}
			})
			
		}
}